module.exports = __webpack_public_path__ + "images/icons_v2/thumbs-down-outlined-4fa6326a.svg";